import request from "@/utils/request";

// 创建推荐活动
export const createPractice = (data) => {
    return request({
        url: "/businessservice/practice/create",
        method: "post",
        data: data
    })
}

// 更新推荐活动
export const updatePractice = (data) => {
    return request({
        url: "/businessservice/practice/update",
        method: "post",
        data: data
    })
}

// 分页查询推荐活动
export const pagePractice = (data) => {
    return request({
        url: "/businessservice/practice/page",
        method: "post",
        data: data
    })
}

// 查询推荐活动信息
export const  infoPractice =(query) =>{
    return request({
        url: "/businessservice/practice/info",
        method:"get",
        params: query
    })
}

// 删除推荐活动信息
export const  deletePractice =(query) =>{
    return request({
        url: "/businessservice/practice/delete",
        method:"get",
        params: query
    })
}

